import React, {FC, useCallback, useContext, useEffect, useState} from 'react'
import {useAuth} from '../providers'
import {CommonService} from '../../app/modules/common'
import {LANGUAGE_KEY} from '../config'
import moment from 'moment'

type LanguageProviderModel = {
  language: any
  setLanguage: any
  handleUpdateLanguage: any
}

const initLanguageContextPropsState = {
  language: 'en',
  setLanguage: () => {},
  handleUpdateLanguage: () => {},
}

const I18nContext = React.createContext<LanguageProviderModel>(initLanguageContextPropsState)
const MetronicI18nProvider: FC = ({children}) => {
  const {currentUser} = useAuth()
  const [language, setLanguage] = useState(
    currentUser?.language || initLanguageContextPropsState.language
  )

  useEffect(() => {
    const lang = currentUser?.language || initLanguageContextPropsState.language
    setLanguage(lang)
    moment.locale(lang === LANGUAGE_KEY.ZH ? 'zh-cn' : lang)
  }, [currentUser?.language])

  const handleUpdateLanguage = useCallback(async (language) => {
    await CommonService.updateUser({language})
    window.location.reload()
  }, [])

  return (
    <I18nContext.Provider value={{language, setLanguage, handleUpdateLanguage}}>
      {children}
    </I18nContext.Provider>
  )
}

const useLanguage = () => {
  return useContext(I18nContext)
}

export {MetronicI18nProvider, useLanguage}
